import React, { Fragment } from 'react';
import PuffLoader from 'react-spinners/PuffLoader';
import styles from '../../styles/css/LoadingInidcator.module.css';

const LoadingIndicator = ({ loading, spinnerSize, showOnComponentLevel }) => {
  return loading ? (
    <div
      className={`${!!loading && !showOnComponentLevel && styles.backdrop} ${
        showOnComponentLevel && styles.compact
      }`}
    >
      <PuffLoader
        color="#1dc4e9"
        loading={!!loading}
        size={spinnerSize || 150}
      />
    </div>
  ) : (
    <Fragment />
  );
};

export default LoadingIndicator;
